import { searchSlice } from './slice';

export const { actions, reducer } = searchSlice;
export * as thunks from './thunks';
export * from './types';
